import { FallbackProps } from "react-error-boundary";

const useErrorBoundary = ({ error, resetErrorBoundary }: FallbackProps) => {
	function handleTryAgain(): void {
		resetErrorBoundary();
	}

	const isDev = import.meta.env.DEV;

	return { handleTryAgain, error, isDev };
};

export default useErrorBoundary;
